module.exports = {
  country: {
    type: 'country',
  },
  city: {},
  region: {},
  continent: {},
  subContinent: {},
  metro: {},
  deviceType: {
    includeEmptyRows: true,
    type: 'deviceType',
  },
  deviceBrand: {
    type: 'deviceBrand',
  },
  deviceModel: {},
  deviceOs: {
    type: 'operatingSystem',
  },
  deviceOsVersion: {
    type: 'number',
  },
  deviceResolution: {},
  browserName: {
    type: 'browser',
  },
  browserVersion: {
    type: 'number',
  },
  browserEngine: {},
  browserLanguage: {
    type: 'language',
  },
  browserLocale: {
    type: 'locale',
  },
  browserCookies: {
    type: 'boolean',
  },
  referrerType: {
    type: 'referrerType',
  },
  referrerName: {},
  referrerUrl: {},
  referrerSearchEngine: {
    filter: {
      combinator: 'and',
      rules: [
        {
          field: 'referrerType',
          operator: 'in',
          valueSource: 'value',
          value: ['search'],
        },
      ],
    },
  },
  referrerSearchKeyword: {
    includeEmptyRows: true,
    filter: {
      combinator: 'and',
      rules: [
        {
          field: 'referrerType',
          operator: 'in',
          valueSource: 'value',
          value: ['search'],
        },
      ],
    },
  },
  referrerWebsite: {
    filter: {
      combinator: 'and',
      rules: [
        {
          field: 'referrerType',
          operator: 'in',
          valueSource: 'value',
          value: ['website'],
        },
      ],
    },
  },
  referrerCampaign: {
    filter: {
      combinator: 'and',
      rules: [
        {
          field: 'referrerType',
          operator: 'in',
          valueSource: 'value',
          value: ['campaign'],
        },
      ],
    },
  },
  referrerSocialNetwork: {
    filter: {
      combinator: 'and',
      rules: [
        {
          field: 'referrerType',
          operator: 'in',
          valueSource: 'value',
          value: ['social'],
        },
      ],
    },
  },
  referrerAI: {
    filter: {
      combinator: 'and',
      rules: [
        {
          field: 'referrerType',
          operator: 'in',
          valueSource: 'value',
          value: ['ai'],
        },
      ],
    },
  },
  campaignContent: {},
  campaignGroup: {},
  campaignKeyword: {},
  campaignMedium: {},
  campaignName: {},
  campaignSource: {},
  campaignId: {},
  campaignPlacement: {},
  visit: {
    unique: true,
  },
  visitFirstActionTime: {
    type: 'datetime',
  },
  visitLastActionTime: {
    type: 'datetime',
  },
  visitorLocalHour: {
    type: 'number',
  },
  visitWebsiteHour: {
    type: 'number',
  },
  pageUrl: {
    type: 'url',
  },
  pagePath: {
    type: 'path',
  },
  pagePathSegment: {
    type: 'pathSegment',
  },
  pageTitle: {},
  outlink: {
    type: 'url',
  },
  outlinkDomain: {
    type: 'domain',
  },
  outlinkPath: {
    type: 'path',
  },
  download: {
    type: 'url',
  },
  downloadDomain: {
    type: 'domain',
  },
  downloadPath: {
    type: 'path',
  },
  visitEntryUrl: {
    type: 'url',
  },
  visitEntryTitle: {},
  visitExitUrl: {
    type: 'url',
  },
  visitExitTitle: {},
  visitCount: {
    type: 'number',
  },
  visitCountGrouped: {
    type: 'number',
  },
  visitDaysSinceFirstVisit: {
    includeEmptyRows: true,
    type: 'number',
  },
  visitDaysSinceLastVisit: {
    includeEmptyRows: true,
    type: 'number',
  },
  visitDaysSinceLastVisitGrouped: {
    includeEmptyRows: true,
    emptyLabel: 'New visits',
    type: 'number',
  },
  eventCategory: {},
  eventName: {},
  eventAction: {},
  eventUrl: {
    type: 'url',
  },
  eventUrlPath: {
    type: 'path',
  },
  siteSearchKeyword: {},
  siteSearchCategory: {},
  questionType: {
    type: 'questionType',
  },
  surveyPageUrl: {},
  surveyPageTitle: {},
  goal: {
    type: 'goal',
  },
};
